<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--查詢取消掛號-->
    <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2>
        <v-progress-linear v-show="loading" :indeterminate="loading"></v-progress-linear> <!--載入進度條 -->
        <v-flex class="xs12 sm12 md9 lg9 ">


            <v-flex style="padding: 0px">
                <v-row class="row--dense">
                    <v-col cols="12" sm="12" md="12" class="ml-2 regBodyFont row--dense">
                     [{{zoneName}}]   初複診 查詢/取消掛號
                    </v-col>

                    <!--<v-col cols="12" sm="12" md="8" style="text-align: right">-->
                    <v-col cols="12" sm="12" md="5" lg="5" class="d-inline-flex">
                        <span  class="regLabel">身分證號/居留證*</span>
                        <v-text-field
                                @keyup="valueToUpperCase()"
                                @keypress="clsAlphaNoOnly"
                                pattern="[A-Z0-9]*"
                                maxlength="10"
                                :rules="[rules.required,rules.idNo1]"
                                @keyup.enter="NextItem('birthDate')"
                                ref="idNo"
                                v-model="idNo"
                                style="display: inline-block"
                                class="regInput"
                                label="身分證號/居留證"
                                clearable
                                solo
                        ></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="12" md="5" lg="5" style="text-align: right" class="d-inline-flex">
                        <span  class="regLabel ">民國生日*</span>
                        <v-text-field
                                pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==7) return false;"
                                :rules="[rules.required,rules.birthCounter,rules.birthFormat]"
                                ref="birthDate"
                                v-model="birthDate"
                                style="display: inline-block"
                                class="regInput hideNum"
                                label="例0950101"
                                clearable
                                type="number"
                                hint="例0950101"
                                solo
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12"  lg="12" style="padding: 0px" class="ml-2 regBodyFont text-right row wrap d-inline-flex">
                        <v-flex class="row--dense xs12 sm12 md12 lg12 d-inline-flex row wrap " style="margin: 0px">
                            <personal-permission  style="max-width: 670px"  :zone-name="zoneName" @agree="agree"></personal-permission>
                            <v-btn class="mt-5 ml-4 mb-2 regFRBtn" :disabled="checkAgree==false" @click="searchReg(idNo,birthDate)">查詢</v-btn>
                        </v-flex>
                        <!--<v-flex class="xs12 sm12 md4 lg4 d-inline-flex row wrap text-left">-->
                            <!--<v-btn  :disabled="checkAgree==false" @click="searchReg(idNo,birthDate)">查詢</v-btn>-->
                        <!--</v-flex>-->

                    </v-col>


                </v-row>
            </v-flex>

            <v-flex class="xs12 sm12 md12 lg12 mt-2">

                <table style="width: 100%" class="clinicTableOutline  elevation-1" >
                    <thead class="clinicNoThead">
                    <tr>
                        <th class="clinicNoTh"></th>
                        <!--<th class="clinicNoTh">院區</th>-->
                        <th class="clinicNoTh">看診日期</th>
                        <th class="clinicNoTh">診間</th>
                        <th class="clinicNoTh">科別</th>
                        <th class="clinicNoTh">醫師</th>
                        <th class="clinicNoTh">看診號</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template>
                        <tr   v-for="(item,index) in regSearchList" :key="index">
                            <td class="text-center clinicNoTd">
                                <v-flex class="clinicNoTdDiv">
                                    <v-btn color="red" dark class="mx-0 " @click="deleteReg(item)"> <!--@click.native.stop="deleteItem(props.item)"-->
                                        取消
                                    </v-btn>
                                </v-flex>
                            </td>
                            <!--<td class="text-center clinicNoTd">-->
                                <!--<v-flex class="clinicNoTdDiv">-->
                                    <!--{{item.zone}}-->
                                <!--</v-flex>-->
                            <!--</td>-->
                            <!--<td class="text-center clinicNoTd">-->
                                <!--<v-flex class="clinicNoTdDiv">-->
                                    <!--{{transFV(item.fvRv)}}-->
                                <!--</v-flex>-->
                            <!--</td>-->
                            <td class="text-center clinicNoTd">
                                <v-flex class="clinicNoTdDiv">
                                    {{item.viewDate }} {{ transApn(item.apn)}}
                                </v-flex>
                            </td>
                            <!--<td class="text-center clinicNoTd">-->
                                <!--<v-flex class="clinicNoTdDiv">-->
                                    <!--{{transApn(item.apn)}}-->
                                <!--</v-flex>-->
                            <!--</td>-->
                            <td class="text-center  clinicNoTd">
                                <v-flex class="clinicNoTdDiv">
                                    {{item.clinicNo}}
                                </v-flex>
                            </td>
                            <td class="text-center  clinicNoTd">
                                <v-flex class="clinicNoTdDiv">
                                    {{item.divName}}
                                </v-flex>
                            </td>
                            <td class="text-center  clinicNoTd">
                                <v-flex class="clinicNoTdDiv">
                                    {{item.doctorName}}
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoLast clinicNoTd">
                                <v-flex class="clinicNoTdDivLast">
                                    {{item.viewNo}}
                                </v-flex>
                            </td>
                        </tr>
                    </template>

                    </tbody>
                </table>
            </v-flex>


        </v-flex>

        <v-flex class="xs12 sm12 md3 lg3">

        </v-flex>

        <v-dialog v-model="errorDialog"
                  persistent
                  :width="dialogWidth+'%'"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  :width="dialogWidth+'%'"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>



        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>
</template>

<script>
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    import PersonalPermission from './PersonalPermission'
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "RegSearchCancel",
        components:{AlertWin,DeleteInfoDialog,PersonalPermission},
        data() {
            return {
                rules:{
                    required: value => !!value || '必填.',
                    birthCounter:value => value!=null && value!=='' && value!==undefined && value.length <= 7 || '最多7個數字',
                    idNo1:v => /^[A-Z]{1}[A-Z1-9]{1}[0-9]{8}$/.test(v) || '身分證號格式錯誤',
                    birthFormat:v=>/^[0-1]?\d{1,2}[0-1]\d[0-3]\d$/.test(v) || '生日格式錯誤',
                },
                zoneName:'',
                loading:false,
                snTimeout:4000,
                snStatus:false,
                snText:'',
                errorDialog:false,
                errorTitle: '',
                errorContent:'',
                aleryType:'error',
                idNo:'',
                birthDate:'',
                regSearchList: [],
                deleteDialog:false,
                deleteTitle:'取消掛號',
                deleteContent:'',
                deleteObj:{},
                checkAgree:false,
                cancelWebReg:'OFF',
                cancelWebRegHint:'',
            }
        },
        computed:{
            dialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {return width = 100}
                if(this.$vuetify.breakpoint.sm == true){return width = 97}
                if(this.$vuetify.breakpoint.md == true){return width = 55}
                if(this.$vuetify.breakpoint.lg == true){return width = 45}
                if(this.$vuetify.breakpoint.xl ==true){return width = 40}
                return  width
            },
        },
        created(){
            this.axios_getRegSetCancelReg();//1100519 是否僅限網掛方式可取消掛號
            this.axios_getZoneName();
        },
        watch:{
            '$route.query': function () { //如果是同一頁面切換 只改變query zone的參數 亦須刷新資料 110/10/18
                this.axios_getRegSetCancelReg();//1100519 是否僅限網掛方式可取消掛號
                this.axios_getZoneName();
            },
        },
        methods:{
            axios_getRegSetCancelReg (){ //是否只限網掛方式可取消掛號 1100519 1101101 修改groupId BASEINFO-> REGCOND
                let url = '';
                this.cancelWebReg = 'OFF';
                this.cancelWebRegHint = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/ONLY_CANCEL_WEBREG";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.cancelWebReg = response.data.resultSet[0].value1;
                        this.cancelWebRegHint = response.data.resultSet[0].value2;
                    }else {
                        this.cancelWebReg = 'OFF';
                    }

                }).catch(error =>  {
                    this.cancelWebReg = 'OFF';
                    this.cancelWebRegHint = '';
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });


            },
            valueToUpperCase(){ //自動將英文字母轉大寫 1101227 by IvyLin
                if(this.idNo!=null&&this.idNo.length>0){
                    this.idNo =  this.idNo.toUpperCase();
                }
            },
            clsAlphaNoOnly (e) {  // Accept only alpha numerics, no special characters //只允許輸入數字和文字 身分證號
                var regex = new RegExp("^[A-Za-z0-9 ]+$");
                var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                // console.log(str)
                if (regex.test(str)) {
                    return true;
                }

                e.preventDefault();
                return false;
            },
            agree(agree){
                this.checkAgree = agree;
            },
            deleteReg(item){
                this.deleteObj = item;
                this.deleteContent = '確定要取消<br/> 看診日期: '+item.viewDate+"<br/>時段: "+this.transApn(item.apn)+"<br/>科別: "+item.divName+"<br/>醫師: "+item.doctorName+"<br/>看診號: "+item.viewNo+"<br/>掛號記錄";
                if(this.cancelWebReg=='ON'){ //如果設定檔 為 true 需判斷 regClerk 為 WEBREG 和 APPREG 方能取消網路掛號 1110111 true/false 改為 ON/OFF
                    if(item.regClerk=='WEBREG'||item.regClerk=='APPREG'){
                        this.deleteDialog = true;
                    }else {
                        // alert(this.cancelWebRegHint)
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.aleryType = 'error';
                        this.errorContent = '<div style="font-size: 1.2rem;font-weight: bold">'+this.cancelWebRegHint+'</div>' ;
                    }
                }else {
                    this.deleteDialog = true;
                }

            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteRegRecord(this.deleteObj);
            },
            transApn(apn){
                if(apn.toString()=="1"){
                    return "早上";
                }else if(apn.toString()=='2') {
                    return "下午";
                }else {
                    return "晚上";
                }
            },
            transFV(fvRv){
                if(fvRv.toString()=="F"){
                    return "初診";
                }else if(fvRv.toString()=='R') {
                    return "複診";
                }else {
                    return "";
                }
            },
            searchReg(idNo,birthDate){
                if(idNo==""||idNo==null||birthDate==""||birthDate==null){
                    alert("請輸入 身分證號和生日")
                }else {
                    this.axios_getSearchRegList(idNo,birthDate,'Y');
                }

            },
            NextItem(nextId){
                this.$refs.[nextId].focus();
            },
            closeErrorDialog(){
                this.errorDialog = false;
            },
            errConfirm(){
                this.closeErrorDialog();
            },
            axios_getSearchRegList(idNo,birthDate,showError){
                this.regSearchList  =[];
                this.loading = true;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = this.$store.state.AppSetting.backSrvUrl+'webcancelregistration/datasearch/'+zone+"/"+idNo+"/"+birthDate;

                this.$http.get(url).then(response=>{

                    // this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.regSearchList  = response.data.resultSet;
                        this.loading = false;
                        // this.snStatus=true;
                        // this.snText = response.data.resultSet[0].rtnMessage;


                    }else if(response.data.resultSet.length==0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        if(showError=='Y'){ //單純查詢顯示錯誤訊息 1100121
                            this.regSearchList  =[];
                            this.errorDialog = true;
                            this.errorTitle = "訊息";
                            this.aleryType = 'error';
                            this.errorContent = '<div style="color: red">身分證號:'+this.idNo+'<br/>'+'生日:'+this.birthDate+'<br/>查無掛號紀錄'+'</div>';
                            this.loading = false;
                        }else { //刪除後查詢 如果查回資料為空 表示刪除掛號紀錄 取消成功  1100121
                            this.regSearchList  =[];
                            this.loading = false;
                        }

                    }else {
                        this.regSearchList  =[];
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.aleryType = 'error';
                        this.errorContent = '<div style="color: red">'+ response.data.message+'</div>';
                        this.snStatus=true;
                        this.snText = response.data.message;
                        this.loading = false;
                    }

                }).catch(error =>{
                    this.regSearchList  =[];
                    this.loading = false;
                        try {
                            let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
                            switch (error.response.status){
                                case 300:
                                case 400:
                                case 401:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.aleryType = 'error';
                                    this.errorContent = '<div style="color: red;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
                                    break;
                                case 404:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.aleryType = 'error';
                                    this.errorContent ="找不到頁面";
                                    break;
                                case 500:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.aleryType = 'error';
                                    this.errorContent = "伺服器錯誤";
                                    break;
                                default:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.aleryType = 'error';
                                    this.errorContent ='<div style="color: red;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
                            }

                        } catch(err) {
                            console.log(err.response.data.message)
                        }


                });
            },
            axios_deleteRegRecord(item){   //刪除單筆資料

                let url =this.$store.state.AppSetting.backSrvUrl +'webcancelregistration/s/'+item.zone+"/"+item.chartNo+"/"+item.viewDate+"/"+item.apn+"/"+item.clinicNo+"/"+item.viewNo;
                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.status=='INFO'&&response.data.hasOwnProperty('resultSet')&&response.data.resultSet.length>0){
                       this.axios_getSearchRegList(item.idNo,item.birthDate,'N');
                        this.deleteDialog = false;
                        this.errorTitle = "訊息";
                        this.aleryType = 'default';
                        this.errorContent = '<div style="color: black;font-size: 1.5rem;font-weight: bold">'+'取消成功'+'</div>';
                        this.errorDialog=true;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .regBodyFont{
        color: #23AAE9;
        font-size: 1.2rem;
    }

    .regLabel{
        margin-top: 12px!important;
        margin-right: 5px;
        width: 130px;
        text-align: right;
    }

</style>